import { conversionRatios, decimalPrecisions } from '@/constants/measurements';
import rootStore from '@/store/RootStore';
import { get, isArray, isNull, isUndefined, toUpper } from 'lodash';

export const convertValue = (
  value: number,
  unit = '',
  toMeasurementSystem?: string,
  fromMeasurementSystem = 'METRIC',
) => {
  if (isUndefined(value) || isNull(value) || isArray(value) || (!isArray(value) && isNaN(value))) return value;

  const actualToMeasurementSystem = toMeasurementSystem || rootStore.userStore.user?.measurementSystem;

  value = isArray(value) ? value : Number(value);

  unit = unit?.toLowerCase();
  const toSystem = toUpper(actualToMeasurementSystem);
  const fromSystem = toUpper(fromMeasurementSystem);

  const convertFn = get(conversionRatios, `from.${fromSystem}.to.${toSystem}.${unit}`, (v: number) => v);
  const precision = getDecimalPrecision(unit, toSystem, fromSystem);
  return isUndefined(precision) ? convertFn(value) : Number(convertFn(value).toFixed(precision));
};

export const getDecimalPrecision = (unit = '', toSystem?: string, fromSystem = 'METRIC') => {
  const decimalPrecision = get(decimalPrecisions, `from.${fromSystem.toUpperCase()}.to.${toSystem?.toUpperCase()}.${unit.toLowerCase()}`);
  return decimalPrecision;
};